// TSS vite/03 §"Query keys convention".

export const breakdownKeys = {
    all:       ['breakdown'],
    tier:      (tierId) => ['breakdown', 'tier', String(tierId)],
    proposals: (tierId, params) => ['breakdown', 'proposals', String(tierId), params],
    // One proposal, found in its tier's list: the only admin read that carries
    // its `spec_revision`.
    proposal:  (tierId, taskId) => ['breakdown', 'proposal', String(tierId), String(taskId)],
};
